/**
 * 결제 취소 판정 — PortOne SDK 를 import 하지 않는 순수 모듈.
 * 앱 시작 시 로드되는 딥링크 핸들러(lib/auth/payment-deep-link.ts)도 쓰므로
 * lib/portone.ts(SDK 포함)와 분리해 둔다.
 */

export interface PaymentFailureSignal {
  code?: string | null;
  message?: string | null;
  pgCode?: string | null;
  pgMessage?: string | null;
}

/**
 * 결제·본인인증 실패 응답이 "사용자가 창을 스스로 닫은 취소"인지 판별한다.
 * 결제 흐름 전 경로(PC 모달·모바일 리다이렉트·완료 화면·앱 딥링크)가 이 함수
 * 하나만 쓴다 — 경로마다 판정이 달라 같은 취소가 어떤 경로에선 실패로 뜨던 문제를 막는다.
 *
 * - `USER_CANCEL` 은 V1 시절 코드. V2 는 창을 닫으면 `FAILURE_TYPE_PG` 를 준다
 *   (Sentry LOCARORA-WEB-53: message "알 수 없는 이유로 실패하였습니다.", pgCode 없음).
 * - PG 가 실제로 거절하면 PG 사유 코드가 붙는다 (LOCARORA-WEB-4T: PG_PROVIDER_ERROR
 *   + pgCode 00FW "거래정지카드"). 그래서 `FAILURE_TYPE_PG` 인데 pgCode 가 없으면 취소로 본다.
 * - PG 원문 메시지에 취소 문구가 있으면 코드와 무관하게 취소.
 */
export function isPaymentUserCancel(signal: PaymentFailureSignal): boolean {
  if (!signal.code) return false;
  if (signal.code === "USER_CANCEL") return true;
  const text = `${signal.message ?? ""} ${signal.pgMessage ?? ""}`;
  if (/취소|cancel|중단|포기/i.test(text)) return true;
  return signal.code === "FAILURE_TYPE_PG" && !signal.pgCode;
}
